import { useState } from "react";

const findOptionValue = (target, options = []) =>
  (options.find(({ value, alt }) => target === value || target === alt) || {})
    .value;

const isDefined = (value) => value !== undefined;

const useChoiceOrValue = (
  options = [],
  defaultValue = undefined,
  defaultSelectValue = "spec"
) => {
  const choice = findOptionValue(defaultValue, options) || defaultSelectValue;
  const [select, setSelect] = useState(choice);
  const [value, setValue] = useState(
    isDefined(defaultValue) ? defaultValue : choice
  );
  return [select === "spec" ? value : select, select, setSelect, setValue];
};

export default useChoiceOrValue;
